module.exports = __webpack_public_path__ + "img/checkmark.376fbf32.svg";